import { render, staticRenderFns } from "./ConsultantSettings.vue?vue&type=template&id=3cc23534&"
import script from "./ConsultantSettings.vue?vue&type=script&lang=js&"
export * from "./ConsultantSettings.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantSettings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports